var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},_vm._l((_vm.proposals),function(proposal){return _c('proposal-list-row',{key:proposal.id,attrs:{"proposal":proposal}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }